module.exports = __webpack_public_path__ + "d68d8669232a9e8215831889eba83db1.otf";